import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllPermissions,
  getAllPermissionsGroup,
} from "../../actions/userActions/permissionsAction";
import Loader from "../subComponents/Loader";
import { Link, useHistory, useLocation } from "react-router-dom";
import Pagination from "../paginatioin/pagination"
import "./Permissions.css";
import { IconButton, Tooltip } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import HeaderComponent from "../reuse_components/HeaderComponent";
import CustomButton from "../subComponents/buttons/CustomButton";
import DynamicTable from "../reuse_components/DynamicTable";
import SearchInput from "../subComponents/search/SearchInput";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddPermissions from "./AddPermissions";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

function PermissionGroup() {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [permission, setPermission] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [permissiondata, setPermissionData] = useState([]);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const dispatch = useDispatch();
  const history = useHistory();

  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const setButtonPermission = () => {
    if(permissions.includes('CanAddPermission')){
      setPermission(true);
    }
  }
  useEffect(() => {
      dispatch(getAllPermissionsGroup(currentPage, itemsPerPage, searchQuery));
  }, [dispatch, currentPage, searchQuery]);

  const allPermissionsGroup = useSelector(
    (state) => state.permissions_reducer.allPermissionsGroup
  );
  const allPermissionsGroupData = allPermissionsGroup?.result || [];
  
  const totalPages = allPermissionsGroup?.totalPages || 0;
  const totalItems = allPermissionsGroup?.totalCount || 0;

  const isLoading = useSelector((state) => state.permissions_reducer.isPermissionGroupLoading);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}&search=${query}`);
  };
 
    const permissionGroupData = allPermissionsGroup && allPermissionsGroupData;
    const PermissionGroupData = permissionGroupData?.map((permissions) => ({
      ...permissions,
      status: (
        <span className={permissions.active ? "status-badge-active" : "status-badge-inactive"}>
          {permissions.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    const handleItemsPerPageChange = (value) => {
      const pageNumber = firstPage;
      dispatch(getAllPermissionsGroup(pageNumber, value, searchQuery));
      setItemsPerPage(value);
      setCurrentPage(1);
    };
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
     { label: `${t("status")}`, accessor: "status" },  
  ];
  
const handleEditPermission = (row) => {
 setEditData(row);
  setShowModal(true);
};
const handleAddPermissionClick = () => {
  setEditData(null);
  setShowModal(true);
};


const handleCloseModal = () => {
  setShowModal(false);
};
const handleSaveData = async () => {
  dispatch(getAllPermissionsGroup(currentPage, itemsPerPage, searchQuery));
  setShowModal(false);
};

  const actions = [  
    {
        label: 'Edit Permission',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }} />,
        permission: 'CanUpdatePermission',
        handler:handleEditPermission,
    },
];

const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
  setCurrentPage(1);
};
  return (
    <>
 <div>
    <LoadingOverlay isVisible={isLoading}/>
      <div className="main-container">
                <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
                        value ={searchQuery}
             />
                <div className="flex-align-center">
                <div className="items-per-page-container">
            <ItemsPerPageSelector
               value={itemsPerPage}
                 onChange={handleItemsPerPageChange}
              />
            </div>
  <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
  {permissions && permissions.includes("CanAddPermission") && (
                            <CustomButton text={t("addNew")} onClick={handleAddPermissionClick} />
                        )}
                    </div>
                </div>
               </div>
               <DynamicTable
                    data={ PermissionGroupData}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
        </div>
        {showModal && (
        <AddPermissions
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
    
    </>
  );
}

export default PermissionGroup;
